import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `Entre 2012 y 2019, la malnutrición por exceso aumentó de manera sostenida en niñas y niños y llegó al 22%. En 2022, la proporción volvió a aumentar y alcanzó el 25% de las y los estudiantes. En 2023, la cifra retornó a los niveles pre-pandemia, con un 22%, y en 2024 la proporción se mantuvo constante. En 2025, la cifra continuó estable y se mantuvo en torno al 22%. Diversas investigaciones a nivel mundial han señalado el impacto significativo de la pandemia en el incremento de la malnutrición por exceso en niñas y niños³ debido al aumento de la inactividad física, la pobreza y el estrés, factores que influyen en esta condición.`,
    link: "https://public.flourish.studio/visualisation/20952443/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `En Chile, los niños presentan una mayor proporción de malnutrición por exceso que las niñas, lo que puede asociarse a que los niños se desarrollan y comienzan su pubertad después que las niñas.[4] También, las diferencias pueden estar influenciadas por las prácticas alimentarias de madres, padres, y familiares, así como a influencias relacionadas con el sexo biológico de nacimiento, como la composición corporal y las hormonas.[5]`,
    link: "https://public.flourish.studio/visualisation/21614448/embed",
  },
  {
    id: "graph3",
    title: "Análisis por curso",
    menuTitle: "\u2022 Curso",
    text: `El curso que presenta una mayor malnutrición por exceso corresponde a 5° básico. En 2018, primera vez que se incluye este curso en la medición, el porcentaje corresponde a un 28%. En 2025, la proporción de niñas y niños de 5° básico con malnutrición por exceso corresponde a 33%. Desde 2012, la proporción de niñas y niños con malnutrición que cursan Educación Parvularia y 1° básico se mantienen relativamente constantes, a excepción del aumento en 2022 respecto a 2019. En 2025, se ubican en un 23% y 26%, respectivamente. Las niñas y los niños de 1° medio son los que presentan una menor proporción de malnutrición por exceso, pero una mayor alza en la última década. En 2012, 1 de cada 10 niñas y niños presentó esta condición y en 2025 lo hizo cerca de 1 cada 5.`,
    link: "https://public.flourish.studio/visualisation/21615933/embed",
  },
  {
    id: "graph4",
    title: "Análisis por dependencia administrativa",
    menuTitle: "\u2022 Dependencia",
    text: `Las diferencias entre colegios públicos y colegios particulares subvencionados en la proporción de estudiantes con malnutrición por exceso son muy pequeñas. Esta brecha, en 2025, no supera 1 punto porcentual.`,
    link: "https://public.flourish.studio/visualisation/21616175/embed",
  },
  {
    id: "graph5",
    title: "Análisis por zona de residencia",
    menuTitle: "\u2022 Zona",
    text: `Desde el 2012, niñas y niños que viven en zonas rurales presentan niveles más altos de malnutrición por exceso que aquellos que habitan en zonas urbanas. En el último año, la diferencia entre ambos fue de 5 puntos porcentuales.`,
    link: "https://public.flourish.studio/visualisation/21616229/embed",
  },
  {
    id: "graph6",
    title: "Análisis por macrozona",
    menuTitle: "\u2022 Macrozona",
    text: `La macrozona Sur es la que presenta una mayor prevalencia de malnutrición por exceso. El último año la malnutrición alcanzó a un 25% de las niñas y los niños. La macrozona Centro es la segunda que tiene una mayor proporción de niñas y niños en esta condición, con un 24% en 2025.`,
    link: "https://public.flourish.studio/visualisation/21616264/embed",
  },
  {
    id: "graph7",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `La distribución de la proporción de niñas y niños con malnutrición por exceso por región tiene la misma que de acuerdo a las macrozonas: las regiones del sur del país concentran la mayor proporción de niñas y niños con malnutrición. Si bien en la mayoría de las regiones la proporción de niñas y niños con malnutrición por exceso en 2025 se mantuvo similar o aumentó levemente respecto a la medición anterior, en la región de Aysén la malnutrición por exceso aumentó 3 puntos porcentuales, siendo la región con el alza más marcada del último año.`,
    link: "https://public.flourish.studio/visualisation/21616450/embed",
  }
];


const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
